/**
 * Returns background and text color for each state.
 */
export const ColorMaker = (name: any) => {

    const CMAp: Record<string, { bg: string, text: string }> = {
        vacation:     { bg: '#FBB17C', text: '#000000' }, // orange (vacation)
        sick:         { bg: '#666666', text: '#FFFFFF' }, // gray (sick)
        working:      { bg: '#008000', text: '#FFFFFF' }, // green (working)
        unapologetic: { bg: '#8B0000', text: '#FFFFFF' }, // dark red
        absent:       { bg: '#00008B', text: '#FFFFFF' }, // dark blue
        training:     { bg: '#8800FF', text: '#FFFFFF' }, // violet
        pause:        { bg: '#B3FFBF', text: '#000000' },  // light green (pause)
        interruption: { bg: '#FFD966', text: '#000000' }  // soft yellow (interrupted work)
    }

    return CMAp[name] ?? CMAp['working']
}
